// extracted by mini-css-extract-plugin
module.exports = {"verified_notification":"VerificationRequiredNotification_verified_notification__PNe5r"};